export const DISPOSE_STORE = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION' as const;
